<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1776"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1780"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1790"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1788" /></clipPath></defs><g
     id="g1782"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1784"><g
         id="g1786"
         clip-path="url(#clipPath1790)"><g
           id="g1792"
           transform="translate(90,382)"><path
             d="M 0,0 H 383.667"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1794" /></g><g
           id="g1796"
           transform="translate(133,422)"><path
             d="m 0,0 v 0 c -11.046,0 -20,8.954 -20,20 v 40 c 0,11.046 8.954,20 20,20 v 0 C 11.046,80 20,71.046 20,60 V 20 C 20,8.954 11.046,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1798" /></g><g
           id="g1800"
           transform="translate(355,422)"><path
             d="M 0,0 V 0 C 11.046,0 20,8.954 20,20 V 60 C 20,71.046 11.046,80 0,80 v 0 C -11.046,80 -20,71.046 -20,60 V 20 C -20,8.954 -11.046,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1802" /></g><g
           id="g1804"
           transform="translate(478,154.6667)"><path
             d="m 0,0 v 286.833 c 0,11.322 -9.178,20.5 -20.5,20.5 H -99"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1806" /></g><g
           id="g1808"
           transform="translate(246.7999,50)"><path
             d="M 0,0 H 98.2"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1810" /></g><g
           id="g1812"
           transform="translate(109.0002,462)"><path
             d="M 0,0 H -78.5 C -89.822,0 -99,-9.178 -99,-20.5 v -371 c 0,-11.322 9.178,-20.5 20.5,-20.5 H 57.8"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1814" /></g><g
           id="g1816"
           transform="translate(331.6668,462)"><path
             d="M 0,0 H -173.667"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1818" /></g><g
           id="g1820"
           transform="translate(329.6674,98)"><path
             d="m 0,0 h -271.667 v 236 h 372 V 80"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1822" /></g><g
           id="g1824"
           transform="translate(502,94)"><path
             d="m 0,0 c 0,46.392 -37.608,84 -84,84 -46.392,0 -84,-37.608 -84,-84 0,-46.392 37.608,-84 84,-84 46.392,0 84,37.608 84,84 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1826" /></g><g
           id="g1828"
           transform="translate(395.1667,94)"><path
             d="m 0,0 20.833,-20.833 38,38"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1830" /></g><g
           id="g1832"
           transform="translate(61.3333,255)"><path
             d="M 0,0 H 367.167"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1834" /></g><g
           id="g1836"
           transform="translate(61.3333,177)"><path
             d="M 0,0 H 343.667"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1838" /></g><g
           id="g1840"
           transform="translate(132.4,334)"><path
             d="M 0,0 V -234.715"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1842" /></g><g
           id="g1844"
           transform="translate(206.8,334)"><path
             d="M 0,0 V -234.715"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1846" /></g><g
           id="g1848"
           transform="translate(281.2,334)"><path
             d="M 0,0 V -234.715"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1850" /></g><g
           id="g1852"
           transform="translate(355.6,334)"><path
             d="M 0,0 V -183"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1854" /></g><g
           id="g1856"
           transform="translate(206.8,50)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1858" /></g><g
           id="g1860"
           transform="translate(50,382)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1862" /></g></g></g></g></svg>
</template>
